"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Capital Service
 * Capital Service OpenAPI specifications
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalDataResidingDurationInYearEnum = exports.PersonalDataResidenceOwnershipStatusEnum = exports.PersonalDataOccupationEnum = exports.PersonalDataEducationEnum = exports.PersonalDataReligionEnum = exports.PersonalDataMaritalStatusEnum = exports.PersonalDataGenderEnum = void 0;
exports.PersonalDataGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE'
};
exports.PersonalDataMaritalStatusEnum = {
    Married: 'MARRIED',
    Single: 'SINGLE',
    DivorcedDeath: 'DIVORCED_DEATH',
    Divorced: 'DIVORCED'
};
exports.PersonalDataReligionEnum = {
    Islam: 'ISLAM',
    Katholik: 'KATHOLIK',
    Kristen: 'KRISTEN',
    Budha: 'BUDHA',
    Hindu: 'HINDU',
    Khonghucu: 'KHONGHUCU',
    Other: 'OTHER'
};
exports.PersonalDataEducationEnum = {
    Elementary: 'ELEMENTARY',
    JuniorSchool: 'JUNIOR_SCHOOL',
    HighSchool: 'HIGH_SCHOOL',
    Diploma: 'DIPLOMA',
    Bachelor: 'BACHELOR',
    Master: 'MASTER',
    Doctorate: 'DOCTORATE'
};
exports.PersonalDataOccupationEnum = {
    O1: 'O1',
    O2: 'O2',
    O3: 'O3',
    O4: 'O4',
    O5: 'O5',
    O6: 'O6',
    O7: 'O7',
    O8: 'O8',
    O9: 'O9',
    O10: 'O10',
    O11: 'O11',
    O12: 'O12',
    O13: 'O13',
    O14: 'O14',
    O15: 'O15',
    O16: 'O16',
    O17: 'O17',
    O18: 'O18',
    O19: 'O19',
    O20: 'O20',
    O21: 'O21',
    O22: 'O22',
    O23: 'O23',
    O24: 'O24',
    O25: 'O25',
    O26: 'O26',
    O27: 'O27',
    O28: 'O28',
    O29: 'O29',
    O30: 'O30',
    O31: 'O31',
    O32: 'O32',
    O33: 'O33',
    O34: 'O34',
    O35: 'O35',
    O36: 'O36',
    O37: 'O37',
    O38: 'O38',
    O39: 'O39',
    O40: 'O40',
    O41: 'O41',
    O42: 'O42',
    O43: 'O43',
    O44: 'O44',
    O45: 'O45',
    O46: 'O46',
    O47: 'O47',
    O48: 'O48',
    O49: 'O49',
    O50: 'O50',
    O51: 'O51',
    O52: 'O52',
    O53: 'O53',
    O54: 'O54',
    O55: 'O55',
    O56: 'O56',
    O57: 'O57',
    O58: 'O58',
    O59: 'O59',
    O60: 'O60',
    O61: 'O61',
    O62: 'O62',
    O63: 'O63',
    O64: 'O64',
    O65: 'O65',
    O66: 'O66',
    O67: 'O67',
    O68: 'O68',
    O69: 'O69',
    O70: 'O70',
    O71: 'O71',
    O72: 'O72',
    O73: 'O73',
    O74: 'O74',
    O75: 'O75'
};
exports.PersonalDataResidenceOwnershipStatusEnum = {
    MilikSendiri: 'MILIK_SENDIRI',
    MilikOrangTua: 'MILIK_ORANG_TUA',
    Sewa: 'SEWA',
    Kos: 'KOS'
};
exports.PersonalDataResidingDurationInYearEnum = {
    Lt1: 'LT1',
    B13: 'B1_3',
    B35: 'B3_5',
    O5: 'O5'
};
